module.exports = __webpack_public_path__ + "static/business-e9c69debca7f646f3feeb4225b93867e.svg";